/**
 * Ticker seed — verbatim port of `TICKER` const from
 * design-reference/predikt-v2/project/site-sections.jsx (lines 34-44).
 *
 * 9 entries × 3 (rendered duplication for seamless infinite scroll, D-23).
 *
 * Phase 3 ships static seed; v1.x HERO-LIVE may swap for live API data,
 * but the marketing-site ticker is intentionally synthetic per PROJECT.md
 * (it advertises the diversity of markets, not the live state of any one).
 *
 * NOTE on 8th entry: design source symbol had a fiat-currency suffix that triggers
 * Phase 1 D-16 brand-vocab ESLint rule. Renamed to 'BTC' (unambiguous
 * in MK financial context; val '94,512' carries no currency unit).
 */
export interface TickerEntry {
  readonly sym: string;
  readonly val: string;
  readonly d: string;
  readonly dir: 'up' | 'down';
}

export const TICKER_SEED: ReadonlyArray<TickerEntry> = [
  { sym: 'MKD/EUR', val: '61.50', d: '+0.02%', dir: 'up' },
  { sym: 'ВАРДАР-ПОБЕДА', val: '0.62', d: '+4.1%', dir: 'up' },
  { sym: 'EU-КАМАТА-ЈУНИ', val: '0.41', d: '+2.8%', dir: 'up' },
  { sym: 'НБА-ЛЕЈКЕРС-ФИНАЛЕ', val: '0.18', d: '−3.2%', dir: 'down' },
  { sym: 'СКОПЈЕ-ДОЖД-САБ', val: '0.74', d: '+0.8%', dir: 'up' },
  { sym: 'ЕВРОВИЗИЈА-МК-ТОП10', val: '0.12', d: '+12.4%', dir: 'up' },
  { sym: 'НАФТА-WTI', val: '78.42', d: '−0.4%', dir: 'down' },
  { sym: 'BTC', val: '94,512', d: '+1.1%', dir: 'up' },
  { sym: 'ОТВОРЕН-ИНТЕРЕС', val: '€2.4M', d: 'ВО ЖИВО', dir: 'up' },
] as const;
